/*
 * @Author: zys22 226208335@qq.com
 * @Date: 2025-10-10 09:59:43
 * @LastEditors: zys22 226208335@qq.com
 * @LastEditTime: 2026-10-12 15:16:09
 * @FilePath: /frasergen-weixin-web/src/store/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react"
import LoginStore from './login.Store'
import ContractProgressStore from './contract_progress.Store'
import ContractManagementStore from './contract_management.Store'
import InvoiceManagementStore from './invoice_management.Store'
import PaymentCollectionStore from './payment_collection.Store'
import PaymentTransferStore from './payment_transfer.Store'



class RootStore {
  // 组合模块
  constructor() {
    this.loginStore = new LoginStore()
    this.lontractProgressStore = new ContractProgressStore()
    this.lontractManagementStore = new ContractManagementStore()
    this.InvoiceManagementStore = new InvoiceManagementStore()
    this.PaymentCollectionStore = new PaymentCollectionStore()
    this.PaymentTransferStore = new PaymentTransferStore()

   
  }
}
// 导入useStore方法供组件使用数据
const StoresContext = React.createContext(new RootStore())
export const useStore = () => React.useContext(StoresContext)